import React, {useCallback, useState} from 'react';
import {
  View,
  Text,
  ImageBackground,
  TouchableOpacity,
  Image,
} from 'react-native';
import {createStyles} from '../../utils/createStyles';
import {useFocusEffect, useNavigation} from '@react-navigation/native';
import MyLearnCenter from './myLearnCenter';
import {useSelector} from 'react-redux';
import {getUserInfo, selectUserInfo} from '../../store/user';
import {useAppDispatch} from '../../store/hooks';
import WrongQuestion from './wrong/wrongQuestion';

export default function MyLearnBeikao() {
  const navigation = useNavigation();
  const userInfo = useSelector(selectUserInfo);
  const dispatch = useAppDispatch();
  const [currentTab, setCurrentTab] = useState(1);
  const focusEffect = useCallback(() => {
    dispatch(getUserInfo()).unwrap();
  }, []);
  useFocusEffect(focusEffect);
  return (
    <>
      <View style={styles.myLearnBox}>
        {currentTab === 1 ? (
          <View style={styles.myLearnBoxLeft}>
            <TouchableOpacity
              onPress={() => {
                // @ts-ignore
                navigation.navigate('MyLearnBeikaoJieduan');
              }}>
              <ImageBackground
                source={{
                  uri: 'https://media.oss.leziedu.com/webapp/classroom/mylearn/bk/mylearn_beikao_jieduan.png?t=1',
                }}
                imageStyle={styles.myLearnBtnStyle}
                style={styles.myLearnBtnStyle}>
                <Text style={styles.myLearnBtnStyleTitle}>阶段测评</Text>
                <Text style={styles.myLearnBtnStyleDesc}>
                  月考、期中、期末测试卷
                </Text>
              </ImageBackground>
            </TouchableOpacity>
            <TouchableOpacity
              onPress={() => {
                // @ts-ignore
                navigation.navigate('MyLearnBeikaoMingxiao');
              }}>
              <ImageBackground
                source={{
                  uri: 'https://media.oss.leziedu.com/webapp/classroom/mylearn/bk/mylearn_beikao_mingxiao.png?t=1',
                }}
                imageStyle={styles.myLearnBtnStyle}
                style={styles.myLearnBtnStyle}>
                <View>
                  <Text style={styles.myLearnBtnStyleTitle}>名校真题</Text>
                  <Text style={styles.myLearnBtnStyleDesc}>
                    全国名校真题试卷
                  </Text>
                </View>
              </ImageBackground>
            </TouchableOpacity>

            <TouchableOpacity
              onPress={() => {
                // Toast.show({
                //   text1: '暂未开放',
                //   text2: '敬请期待',
                //   visibilityTime: 2000,
                //   position: 'top',
                // });
                // @ts-ignore
                navigation.navigate('MyLearnBeikaoZhuanti');
              }}>
              <ImageBackground
                source={{
                  uri: 'https://media.oss.leziedu.com/webapp/classroom/mylearn/bk/mylearn_beikao_zhuanti.png?t=1',
                }}
                imageStyle={styles.myLearnBtnStyle}
                style={styles.myLearnBtnStyle}>
                <Text style={styles.myLearnBtnStyleTitle}>
                  {userInfo.xkwStageId
                    ? userInfo.xkwStageId === 1
                      ? ''
                      : userInfo.xkwStageId === 2
                      ? '小升初'
                      : userInfo.xkwStageId === 3
                      ? '中考'
                      : userInfo.xkwStageId === 4
                      ? '高考'
                      : ''
                    : userInfo.studyPhase === 2
                    ? '小升初'
                    : userInfo.studyPhase === 3
                    ? '中考'
                    : userInfo.studyPhase === 4
                    ? '高考'
                    : ''}
                  专题训练
                </Text>
                <Text style={styles.myLearnBtnStyleDesc}>
                  {userInfo.xkwStageId
                    ? userInfo.xkwStageId === 1
                      ? ''
                      : userInfo.xkwStageId === 2
                      ? '小升初'
                      : userInfo.xkwStageId === 3
                      ? '中考'
                      : userInfo.xkwStageId === 4
                      ? '高考'
                      : ''
                    : userInfo.studyPhase === 2
                    ? '小升初'
                    : userInfo.studyPhase === 3
                    ? '中考'
                    : userInfo.studyPhase === 4
                    ? '高考'
                    : ''}
                  专题试卷
                </Text>
              </ImageBackground>
            </TouchableOpacity>
          </View>
        ) : currentTab === 2 ? (
          <View style={styles.flex1}>
            <MyLearnCenter />
          </View>
        ) : (
          <View style={styles.flex1}>
            <WrongQuestion />
          </View>
        )}
        <View style={{flexDirection: 'row', alignItems: 'center'}}>
          <View style={styles.myLearnBoxRight}>
            <TouchableOpacity
              activeOpacity={0.6}
              onPress={() => {
                setCurrentTab(1);
              }}
              style={styles.workBookDetailsBoxBtnItem}>
              <Image
                style={styles.workBookDetailsBoxBtnItemImg}
                source={{
                  uri:
                    currentTab === 1
                      ? 'https://media.oss.leziedu.com/webapp/classroom/mylearn/mylearn_beikao_a.png'
                      : 'https://media.oss.leziedu.com/webapp/classroom/mylearn/mylearn_beikao.png',
                }}
              />
              <View
                style={[
                  styles.workBookDetailsBoxBtnItemBox,
                  currentTab === 1 && styles.workBookDetailsBoxBtnItemBoxA,
                ]}>
                <Text style={styles.workBookDetailsBoxBtnItemText}>
                  AI 备考
                </Text>
              </View>
            </TouchableOpacity>
            <TouchableOpacity
              activeOpacity={0.6}
              onPress={() => {
                // @ts-ignore
                setCurrentTab(2);
              }}
              style={styles.workBookDetailsBoxBtnItem}>
              <Image
                style={styles.workBookDetailsBoxBtnItemImg}
                source={{
                  uri:
                    currentTab === 2
                      ? 'https://media.oss.leziedu.com/webapp/classroom/mylearn/mylearn_center_a.png'
                      : 'https://media.oss.leziedu.com/webapp/classroom/mylearn/mylearn_center.png',
                }}
              />
              <View
                style={[
                  styles.workBookDetailsBoxBtnItemBox,
                  currentTab === 2 && styles.workBookDetailsBoxBtnItemBoxA,
                ]}>
                <Text style={styles.workBookDetailsBoxBtnItemText}>
                  我的学案
                </Text>
              </View>
            </TouchableOpacity>

            <TouchableOpacity
              activeOpacity={0.6}
              onPress={() => {
                // @ts-ignore
                setCurrentTab(3);
              }}
              style={styles.workBookDetailsBoxBtnItem}>
              <Image
                style={styles.workBookDetailsBoxBtnItemImg}
                source={{
                  uri:
                    currentTab === 3
                      ? 'https://media.oss.leziedu.com/webapp/classroom/wrong/cuoti_icon_yes.png'
                      : 'https://media.oss.leziedu.com/webapp/classroom/wrong/cuoti_icon_no.png',
                }}
              />
              <View
                style={[
                  styles.workBookDetailsBoxBtnItemBox,
                  currentTab === 3 && styles.workBookDetailsBoxBtnItemBoxA,
                ]}>
                <Text style={styles.workBookDetailsBoxBtnItemText}>错题本</Text>
              </View>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </>
  );
}
const styles = createStyles({
  flex1: {
    flex: 1,
  },
  myLearnBox: {
    flex: 1,
    flexDirection: 'row',
    backgroundColor: '#fff',
  },
  myLearnBoxLeft: {
    flex: 1,
    padding: '7rem',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  myLearnBtnStyle: {
    width: '24.2rem',
    height: '32rem',
    // marginLeft: '9rem',
    padding: '2.65rem',
  },
  myLearnBtnStyleTitle: {
    fontSize: '1.9rem',
    color: '#3D3D3D',
  },
  myLearnBtnStyleDesc: {
    marginTop: '0.25rem',
    fontSize: '1.2rem',
    color: '#B6B6B6',
  },
  myLearnBoxRight: {
    marginRight: '2.55rem',
    marginLeft: '0.8rem',
    width: '7.25rem',
    height: '32.25rem',
    backgroundColor: '#6F63FF',
    borderRadius: '1.75rem',
    flexDirection: 'column',
    justifyContent: 'space-around',
    alignItems: 'center',
  },
  workBookDetailsBoxBtnItem: {
    flexDirection: 'column',
    alignItems: 'center',
  },
  workBookDetailsBoxBtnItemImg: {
    width: '3.25rem',
    height: '3.25rem',
    marginBottom: '0.75rem',
  },
  workBookDetailsBoxBtnItemText: {
    color: '#fff',
    fontSize: '1.125rem',
  },

  workBookDetailsBoxBtnItemBox: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    width: '6.1rem',
    height: '2.1rem',
    // borderRadius: '1.05rem',
  },
  workBookDetailsBoxBtnItemBoxA: {
    borderRadius: '1.05rem',
    backgroundColor: '#543DFF',
  },
});
